export const NOT_FOUND = 'NOT_FOUND';

export function formatViewDateInterval(msg, startDate, endDate) {
  if (startDate && endDate && startDate !== endDate) {
    return msg({ id: 'view.common.date.interval' }, { startDate, endDate });
  }
  return msg({ id: 'view.common.date.single' }, { date: startDate || endDate });
}

/**
 * Checks if a message contains a variable.
 * @param msg the message
 * @returns {*|boolean} true if the message contains a variable
 */
export function containsVariable(msg) {
  const res = msg.match(/\{[a-zA-Z0-9_]+\}/);
  return res && res.length >= 1;
}
